{
  "@context": "https://schema.org",
  "@type": "Game",
  "name": "Defuse",
  "alternateName": [
    "bomb defusal game", "defuse the bomb game", "game to defuse bomb"
  ],
  "description": "A strategy-based game where players must defuse a bomb before time runs out.",
  "url": "https://6cs.fail/en/defuse"
}
